import AScene from "../../library/ExtendedObjects/AScene"
import gameData from "../../gameData.js";
import ABCyaPhaser, { Audio, Images } from "@abcya/abcya_phaser";
import muteButton from "../../library/muteButton";
import LocalizationSoundAssetKeys from "../../Localization-SoundAssetKeys";
import FontKeys from "../../FontKeys.js";

export default class MakeACake extends AScene
{
    static get KEY() { return 'MakeACake'; }
    create()
    {
        var i;
        var TintButton = [];
        this.TintTween;
        this.Cake;

        this.addImage(this.mid.x, this.mid.y, "Background.png");
        this.Plate = this.addImage(this.mid.x, this.mid.y-20, "Plate.png");
        this.Cake = this.addImage(this.mid.x, this.mid.y+20, "MCake.png");
        this.Instructions = ABCyaPhaser.Text.addText(this.mid.x, this.mid.y+84, 48, 0xc063fc, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("make_a_cake_screens.pick_color_screen.instructions"), this).setShadow(-2, 1, "#7e2f91");

        this.Cake.setOrigin(.5,1);

        this.SoundCheck("tween_up");

        this.AddHomeButton();
        muteButton(this)
        this.AddNextButton();

        for (i=0; i<10;i++)
        {
            TintButton[i] = this.addImage(51 + (i* 102), this.mid.y + 150, "Cake Color/Clr_"+(i+1)+".png");
            TintButton[i].number = i;
            TintButton[i].on('pointerdown',function()
            {
                this.scene.SetCakeTint(this.number);
                this.scene.SoundCheck("button_menu_click");
            });
            TintButton[i].setInteractive();
        }

        for (i=10; i<20;i++)
        {
            TintButton[i] = this.addImage(51 + ((i-10)* 102), this.mid.y + 250, "Cake Color/Clr_"+(i+1)+".png");
            TintButton[i].number = i;
            TintButton[i].on('pointerdown',function()
            {
                this.scene.SetCakeTint(this.number);
                this.scene.SoundCheck("button_menu_click");
            });
            TintButton[i].setInteractive();
        }

        this.TintTween = TintButton;
        this.EverythingTweenIn();
    }//End of on create

    //Button Section
    SetCakeTint(i)
        {
            var TintList =
                [
                    0xffffff,
                    0x424242,
                    0x7c3f09,
                    0xca6c15,
                    0xfcb984,
                    0x5e9afc,
                    0x88d159,
                    0x5ce0be,
                    0x68f2ee,
                    0x62d5ef,
                    0x5f40d3,
                    0xa554f7,
                    0xdd67f9,
                    0xff5cae,
                    0xff97d0,
                    0xc32139,
                    0xef4f3b,
                    0xfedc4b,
                    0xf9af1e,
                    0xff8c3d,
                ];
            gameData.CakeTint = TintList[i];
            this.Cake.setTint(TintList[i]);
        }
    
    SoundCheck(sound)
        {
            if (gameData.gameMuted != true)
            {
                this.playSound(sound);
            }
        }

    AddHomeButton()
        {   
            var MenuBack;
            var YesBtn;
            var NoBtn;
            this.HomeBtnGroup = this.add.group();
            var Quit;

            this.HomeButton = this.addButton(50,this.mid.y + this.mid.y - 40, "NewAsset/Btn_Home.png", null, ()=>{
                
                this.SoundCheck("button_menu_click");
                Quit = this.playSound(LocalizationSoundAssetKeys._are_you_sure_you_want_to_quit, 1, false, true, Audio.LOCALIZATION_AUDIO_SPRITE);
                this.HomeButton.setEnabled(false);

                this.PauseBackDrop = this.add.rectangle(0,0,1024,768,'#333840',.3).setInteractive();
                this.PauseBackDrop.setOrigin(0,0);

                //this.scene.pause();
                //this.scene.launch("PauseMenu");

                let menuBg = this.addImage(this.mid.x,this.mid.y,"NewAsset/Quit_Popup.png");
                MenuBack = ABCyaPhaser.Text.addText(522, 314,60, 0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("confirm_popup.quit_text"), this).setShadow(-4, 1,"#f58a1f").setWordWrapWidth(550).setPadding(4,4);

                YesBtn = this.addButton(this.mid.x - 148.75,this.mid.y,"Yes.png");
                let yesBtnTxt = ABCyaPhaser.Text.addText(365, 442,48,  0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("confirm_popup.yes_button"), this).setShadow(-4, 1,"#f58a1f").setPadding(4,4)
                NoBtn = this.addButton(this.mid.x + 148.75,this.mid.y,"No.png");
                let noBtnTxt = ABCyaPhaser.Text.addText(664, 441,48,  0xffe2be, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("confirm_popup.no_button"), this).setShadow(-4, 1,"#f58a1f")

                // MenuBack = this.addImage(this.mid.x,this.mid.y,"NewAsset/Quit_Popup.png");

                // YesBtn = this.addButton(this.mid.x - 148.75,this.mid.y,"Yes.png");
                // NoBtn = this.addButton(this.mid.x + 148.75,this.mid.y,"No.png");
                
                this.HomeBtnGroup.addMultiple([YesBtn,NoBtn,MenuBack]);

                //for(x in this.HomeBtnGroup.children.entries)
                //{ 
                   // this.HomeBtnGroup.children.entries[x].setDepth(6);
                //}

                YesBtn.on('pointerdown',()=>
                {
                        this.SoundCheck("button_menu_click");
                        YesBtn.setEnabled(false);
                        NoBtn.setEnabled(false);
                        this.sound.stopAll();
                        this.scene.start("Intro");

                });

                NoBtn.on('pointerdown',()=>
                {
                        this.SoundCheck("button_menu_click");
                        YesBtn.setEnabled(false);
                        NoBtn.setEnabled(false);          
                        this.PauseBackDrop.destroy(); 
                        Quit.stop();
                        this.DestroyMenu(YesBtn,NoBtn,MenuBack, menuBg, yesBtnTxt, noBtnTxt);
                });
            });
            this.HomeButton.PlaySound = false;
            this.HomeButton.setOrigin(.5,.5);
        }

    AddNextButton()
        {
            this.NextButton = this.add.container(this.mid.x, this.scale.height-40, [
              ABCyaPhaser.Images.addImage(0,0,"Cake Color/Next.png",this),
              ABCyaPhaser.Text.addText(0,-5,60, 0xf8d7ff, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString("make_a_cake_screens.pick_color_screen.next_button"), this).setShadow(-2, 1, "#9842db")
            ]);
            ABCyaPhaser.Text.resizeFontToFitWidth(this.NextButton.getAt(1), 140)
            ABCyaPhaser.Container.setContainerInteractive(this.NextButton);
            ABCyaPhaser.Buttons.convertToButton(this.NextButton, {
              onClick: ()=>{
                this.NextButton.disableInteractive();
                this.SoundCheck("button_menu_click");
                this.TintButtonTweenOut();
                this.NextAInstructionsTweenOut();
                this.CircleRollOut(-100,this.HomeButton,500,Phaser,Phaser.Math.Easing.Quadratic.InOut);
                if (this.SoundOnButton.visible === false)
                {
                    this.CircleRollOut(100,this.SoundOffButton,500,Phaser,Phaser.Math.Easing.Quadratic.InOut);
                }
                else 
                {
                    this.CircleRollOut(100,this.SoundOnButton,500,Phaser,Phaser.Math.Easing.Quadratic.InOut);
                }
                this.CakeAPlate();//Calls next scene
                //this.scene.start("MakeACakePlacer");
              },
              pressAnimationConfig: {scaleX: this.scaleX < 0 ? -.9 : .9, scaleY: this.scaleY < 0 ? -.9 : .9},
              releaseAnimationConfig: { scaleX: this.scaleX < 0 ? -1 : 1, scaleY: this.scaleY < 0 ? -1 : 1}
            });

            this.NextButton.PlaySound = false;
        }

    DestroyMenu(Y,N,M, BG, yTxt, nTxt)
        {
            Y.destroy();
            N.destroy();
            M.destroy();
            BG.destroy();
            yTxt.destroy();
            nTxt.destroy();
            this.addDelay(100)
            {
                this.HomeButton.setEnabled(true);
            }
        }
    //Tweens
    EverythingTweenIn()
        {
            this.children.getChildren().forEach((child)=>
            {
                if(child.type === "Graphics")
                {
                    return;
                }
    
                if(child.frame?.name === "Background.png")
                {
                    return;
                }
    
    
                this.addTween(child,800, {y:{start: child.y + 1000, to: child.y}},Phaser.Math.Easing.Quadratic.InOut);
            });
        }
    TintButtonTweenOut()
        {
            var x;
            for (x = 0; x<10;x++)
            {
                this.addTween(this.TintTween[x], 800,{scale:0,delay:x * 50},Phaser.Math.Easing.Elastic.Out);
                this.addTween(this.TintTween[19-x], 800,{scale:0,delay:x * 50},Phaser.Math.Easing.Elastic.Out);
            }
        }
    
    NextAInstructionsTweenOut()
        {
            this.addTween(this.NextButton, 200,{y: this.NextButton.y - 20},Phaser.Math.Easing.Bounce.Out);
            this.addTween(this.Instructions, 200,{y: this.Instructions.y - 20},Phaser.Math.Easing.Bounce.Out,()=>
            {
                this.addTween(this.NextButton, 500,{y: this.NextButton.y + 500},Phaser.Math.Easing.Quadratic.In);
                this.addTween(this.Instructions, 500,{y: this.Instructions.y + 500},Phaser.Math.Easing.Quadratic.In);
            });
        }

    CircleRollOut(Distance,Object,TimeTaken,Ease)
        {
            var Rotation;

            Rotation = Distance/(Object.width/2);
            this.addTween(Object,TimeTaken,{rotation: Rotation, x: Object.x + Distance},Ease);
        }

    CakeAPlate()
        {
            this.SoundCheck("cake_fall");
            this.addTween(this.Plate, 300,{x:this.Plate.x+1000},Phaser.Math.Easing.Quadratic.In);
            this.addTween(this.Cake, 300,{angle:-.5},Phaser.Math.Easing.Quadratic.In,()=>
            {
                this.addTween(this.Cake, 50,{angle: {start: -.5,from:.5, to:0}, loop: 4, loopCounter: 0},Phaser.Math.Easing.Quadratic.In,()=>
                {
                    this.addTween(this.Cake, 600,{y: 1600},Phaser.Math.Easing.Quadratic.In,()=>
                    {
                        this.scene.start("MakeACakePlacer");
                    });
                });
            });

        }
    //End Tweens
}